// One-line glossary definitions for acronyms auto-linked on Services and Technology pages.
// Kept intentionally short (single sentence) to fit inside a tooltip.

export const TERM_DEFS = {
  HMBD:
    "Heat & Mass Balance Diagram — tracks material and energy through a plant to confirm the design performs as expected.",
  "P&ID":
    "Piping and Instrumentation Diagram — a detailed drawing showing every pipe, valve, and control system in a plant.",
  FEED:
    "Front-End Engineering Design — detailed technical planning before construction, defining how a plant will be built and sized.",
  PFD:
    "Process Flow Diagram — a high-level diagram of the main process steps in a plant.",
  UFD:
    "Utility Flow Diagram — a high-level diagram of supporting utilities like steam, water, and power.",
  TEA:
    "Techno-Economic Assessment — evaluates whether a project makes financial sense.",
  TEEA:
    "Techno-Economic & Environmental Assessment — a TEA extended into environmental and social factors.",
  DPR:
    "Detailed Project Report — the comprehensive document laying out a project's technical, financial, and carbon methodology details.",
  PDD:
    "Project Design Document — the carbon-methodology counterpart to a DPR, submitted to registries.",
  CAPEX: "Capital Expenditure — the upfront cost to build a plant.",
  OPEX: "Operating Expenditure — the ongoing cost to run a plant.",
  HAZOP:
    "Hazard and Operability Study — a structured safety review that identifies potential hazards before construction.",
  ATFE:
    "Agitated Thin Film Evaporator — equipment used to purify liquids like bio-oil via thin-film evaporation.",
  PLC:
    "Programmable Logic Controller — the hardware that automates plant operations.",
  SCADA:
    "Supervisory Control and Data Acquisition — the software letting operators monitor and control the plant remotely.",
  MRV:
    "Measurement, Reporting & Verification — the process of proving a carbon removal claim is real and independently verified.",
  LCA:
    "Life Cycle Assessment — a full accounting of a product's environmental impact across its entire life.",
  CDR:
    "Carbon Dioxide Removal — a process that actively removes CO₂ already in the atmosphere and stores it durably.",
  EBC:
    "European Biochar Certificate — a widely recognized quality and safety standard for biochar, with a Feed category certified for animal feed.",
  ISCC:
    "International Sustainability & Carbon Certification — a global certification for sustainable biomass and biofuels, often required for EU markets.",
};

// Map acronym → Learn page anchor slug so tooltips can link deep.
export const TERM_SLUGS = {
  HMBD: "hmbd",
  "P&ID": "pid",
  FEED: "feed",
  PFD: "pfd-ufd",
  UFD: "pfd-ufd",
  TEA: "tea-teea",
  TEEA: "tea-teea",
  DPR: "dpr-pdd",
  PDD: "dpr-pdd",
  CAPEX: "capex-opex",
  OPEX: "capex-opex",
  HAZOP: "hazop",
  ATFE: "atfe",
  PLC: "plc-scada",
  SCADA: "plc-scada",
  MRV: "mrv",
  LCA: "lca",
  CDR: "cdr",
  EBC: "ebc",
  ISCC: "iscc",
};

// Ordered longest-first so multi-char tokens win before their prefixes (e.g. TEEA before TEA).
export const TERM_TOKENS = Object.keys(TERM_DEFS).sort((a, b) => b.length - a.length);
